import React, { Component } from 'react'
import Select from 'react-select'
import { Options, QtyMinus, QtyPlus, Plus } from './icons'
import Link from '../utils/link'
import autoComplete from '@tarekraafat/autocomplete.js'
import { property } from 'lodash'

let categories = [
  { label: "For Sale", value: 'for-sale' },
  { label: "For Lease", value: 'for-lease' },
  { label: "Sold", value: 'sold' },
]

let propertyType = [
  { label: "Residential", value: 'residential' },
  { label: "Commercial", value: 'commercial' },
]

let typeOptions = [
  { label: "House", value: 'House' },
  { label: "Townhouse", value: 'Townhouse' },
  { label: "Apartment", value: 'Apartment' },
  { label: "Unit", value: 'Unit' },
]

const rentRangeMin = [
  { label: "$0", value: 0 },
  { label: "$100", value: 100 },
  { label: "$200", value: 200 },
  { label: "$300", value: 300 },
  { label: "$400", value: 400 },
  { label: "$500", value: 500 },
  { label: "$600", value: 600 },
  { label: "$700", value: 700 },
  { label: "$800", value: 800 },
  { label: "$900", value: 900 },
  { label: "$1,000", value: 1000 },
  { label: "$1,500", value: 1500 },
  { label: "$2,000", value: 2000 },
  { label: "$2,500", value: 2500 },
  { label: "$3,000", value: 3000 },
  { label: "$4,000", value: 4000 },
  { label: "$5,000", value: 5000 },
]

const rentRangeMax = [
  { label: "$0", value: 0 },
  { label: "$100", value: 100 },
  { label: "$200", value: 200 },
  { label: "$300", value: 300 },
  { label: "$400", value: 400 },
  { label: "$500", value: 500 },
  { label: "$600", value: 600 },
  { label: "$700", value: 700 },
  { label: "$800", value: 800 },
  { label: "$900", value: 900 },
  { label: "$1,000", value: 1000 },
  { label: "$1,500", value: 1500 },
  { label: "$2,000", value: 2000 },
  { label: "$2,500", value: 2500 },
  { label: "$3,000", value: 3000 },
  { label: "$4,000", value: 4000 },
  { label: "$5,000", value: 5000 },
  { label: "$10,000", value: 99999 },
]

const priceRangeMin = [
  { label: "$100,000", value: 100000 },
  { label: "$200,000", value: 200000 },
  { label: "$300,000", value: 300000 },
  { label: "$400,000", value: 400000 },
  { label: "$500,000", value: 500000 },
  { label: "$600,000", value: 600000 },
  { label: "$700,000", value: 700000 },
  { label: "$800,000", value: 800000 },
  { label: "$900,000", value: 900000 },
  { label: "$1,000,000", value: 1000000 },
  { label: "$1,500,000", value: 1500000 },
  { label: "$2,000,000", value: 2000000 },
  { label: "$2,500,000", value: 2500000 },
  { label: "$3,000,000", value: 3000000 },
  { label: "$3,500,000", value: 3500000 },
  { label: "$4,000,000", value: 4000000 },
  { label: "$4,500,000", value: 4500000 },
  { label: "$5,000,000", value: 5000000 },
  { label: "$5,500,000", value: 5500000 },
  { label: "$6,000,000", value: 6000000 },
  { label: "$6,500,000", value: 6500000 },
  { label: "$7,000,000", value: 7000000 },
  { label: "$7,500,000", value: 7500000 },
  { label: "$8,000,000", value: 8000000 },
  { label: "$8,500,000", value: 8500000 },
  { label: "$9,000,000", value: 9000000 },
  { label: "$9,500,000", value: 9500000 },
  { label: "$10,000,000", value: 100000000 },
  { label: "$12,000,000", value: 120000000 },
  { label: "$15,000,000", value: 150000000 },
  { label: "$20,000,000", value: 200000000 },
  { label: "$30,000,000", value: 999999999 },
]

const priceRangeMax = [
  { label: "$500,000", value: 500000 },
  { label: "$600,000", value: 600000 },
  { label: "$700,000", value: 700000 },
  { label: "$800,000", value: 800000 },
  { label: "$900,000", value: 900000 },
  { label: "$1,000,000", value: 1000000 },
  { label: "$1,500,000", value: 1500000 },
  { label: "$2,000,000", value: 2000000 },
  { label: "$2,500,000", value: 2500000 },
  { label: "$3,000,000", value: 3000000 },
  { label: "$3,500,000", value: 3500000 },
  { label: "$4,000,000", value: 4000000 },
  { label: "$4,500,000", value: 4500000 },
  { label: "$5,000,000", value: 5000000 },
  { label: "$5,500,000", value: 5500000 },
  { label: "$6,000,000", value: 6000000 },
  { label: "$6,500,000", value: 6500000 },
  { label: "$7,000,000", value: 7000000 },
  { label: "$7,500,000", value: 7500000 },
  { label: "$8,000,000", value: 8000000 },
  { label: "$8,500,000", value: 8500000 },
  { label: "$9,000,000", value: 9000000 },
  { label: "$9,500,000", value: 9500000 },
  { label: "$10,000,000", value: 100000000 },
  { label: "$12,000,000", value: 120000000 },
  { label: "$15,000,000", value: 150000000 },
  { label: "$20,000,000", value: 200000000 },
  { label: "$30,000,000", value: 999999999 },
]

class ClickSearchForm extends Component {

  state = {
    mobileSearch: false,
    moreOptions: false,
    searchPlaceholder: `Search`,
    action: '/for-sale/',
    search: '',
    property_type: { label: "Residential", value: 'residential' },
    category: { label: "For Sale", value: 'for-sale' },
    bedrooms: 0,
    bathrooms: 0,
    carparks: 0,
    price_min: null,
    price_max: null,
    location: null,
    type: null,
    results: [],
    suburbs: [],
    autocomplete: false,
  }

  componentDidMount() {
    this.updateDimensions()
    window.addEventListener("resize", this.updateDimensions)
    if (this.props.home) {
      this.autoCompleteJS = null
      let results = []
      let suburbs = []
      this.props.forSale.forEach((el, i) => {
        if (!el.propertyAddress.hideAddress) {
          results.push({
            title: el.title,
          })
        }
        let suburb = el.propertyAddress.suburb.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        suburbs.push(suburb);
      })
      this.props.staff.allWpTeam.nodes.forEach((el, i) => {
        results.push({
          title: el.title,
        })
      })
      suburbs = suburbs.filter((v, i, a) => a.indexOf(v) === i);
      suburbs.sort()
      this.setState({ results, suburbs })
      setTimeout(() => {
        this.autoComplete()
      }, 500)
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions)
  }

  updateDimensions = () => {
    if(window.innerWidth < 900) {
      this.setState({ searchPlaceholder: `Start your search` });
    } else {
      this.setState({ searchPlaceholder: `Search address, area or agent` });
    }
  }

  handleSelectChange = (option, field) => {
    let state = {}
    
    let results = []

    let suburbs = []

    if (field.name === 'category') {
      state['action'] = `/${option.value}/`
      if (this.props.home) {
        if (this.state.property_type.value === 'commercial') {
          state['action'] = `/commercial-${option.value}/`
        }
        if (option.value === 'for-lease') {
          if (this.state.property_type.value === 'commercial') {
            state['action'] = `/commercial-lease/`
            this.props.commercialLease.forEach((el, i) => {
              results.push({
                title: el.title,
              })
              let suburb = el.propertyAddress.suburb.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
              suburbs.push(suburb);
            })
          } else {
            this.props.lease.forEach((el, i) => {
              results.push({
                title: el.title,
              })
              let suburb = el.propertyAddress.suburb.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
              suburbs.push(suburb);
            })
          }
        }
        if (option.value === 'sold') {
          if (this.state.property_type.value === 'commercial') {
            this.props.commercialSold.forEach((el, i) => {
              results.push({
                title: el.title,
              })
              let suburb = el.propertyAddress.suburb.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
              suburbs.push(suburb);
            })
          } else {
            this.props.sold.forEach((el, i) => {
              results.push({
                title: el.title,
              })
              let suburb = el.propertyAddress.suburb.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
              suburbs.push(suburb);
            })
          }
        }
        if (option.value === 'for-sale') {
          if (this.state.property_type.value === 'commercial') {
            this.props.commercialSale.forEach((el, i) => {
              results.push({
                title: el.title,
              })
              let suburb = el.propertyAddress.suburb.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
              suburbs.push(suburb);
            })
          } else {
            this.props.forSale.forEach((el, i) => {
              results.push({
                title: el.title,
              })
              let suburb = el.propertyAddress.suburb.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
              suburbs.push(suburb);
            })
          }
        }
        this.props.staff.allWpTeam.nodes.forEach((el, i) => {
          results.push({
            title: el.title,
          })
        })
        suburbs = suburbs.filter((v, i, a) => a.indexOf(v) === i);
        suburbs.sort()
        this.setState({results, suburbs}, this.autoComplete)
      }
    }
    if (field.name === 'property_type') {
      if (this.props.home) {
        if (this.state.category?.value === 'for-lease') {
          if (option.value === 'commercial') {
            state['action'] = `/commercial-lease/`
            this.props.commercialLease.forEach((el, i) => {
              results.push({
                title: el.title,
              })
            })
          } else {
            state['action'] = `/for-lease/`
            this.props.lease.forEach((el, i) => {
              results.push({
                title: el.title,
              })
            })
          }
        }
        if (this.state.category?.value === 'sold') {
          if (option.value === 'commercial') {
            state['action'] = `/commercial-sold/`
            this.props.commercialSold.forEach((el, i) => {
              results.push({
                title: el.title,
              })
            })
          } else {
            state['action'] = `/sold/`
            this.props.sold.forEach((el, i) => {
              results.push({
                title: el.title,
              })
            })
          }
        }
        if (this.state.category?.value === 'for-sale') {
          if (option.value === 'commercial') {
            state['action'] = `/commercial-for-sale/`
            this.props.commercialSale.forEach((el, i) => {
              results.push({
                title: el.title,
              })
            })
          } else {
            state['action'] = `/for-sale/`
            this.props.forSale.forEach((el, i) => {
              results.push({
                title: el.title,
              })
            })
          }
        }
        this.props.staff.allWpTeam.nodes.forEach((el, i) => {
          results.push({
            title: el.title,
          })
        })
        this.setState({results}, this.autoComplete)
      }
    }
    switch (field && field.action) {
      case 'select-option':
        state[field.name] = option
        break
      case 'mount':
        let { name, value } = option.currentTarget
        let item = this[name]?.props?.options?.find(el => el.value == value)
        if (item) {
          state[name] = item
        }
        break
      default:
        state[option.currentTarget.name] = option.currentTarget.value
        break
    }
    this.setState(state)
  }

  handleBedrooms = (operator) => {
    let { bedrooms } = this.state
    if (operator === 'plus') {
      bedrooms = bedrooms + 1
      if (bedrooms > 10) bedrooms = 10
    } else {
      bedrooms = bedrooms - 1
      if (bedrooms < 0) bedrooms = 0
    }
    this.setState({ bedrooms }, this.updateList)
  }
  handleBaths = (operator) => {
    let { bathrooms } = this.state
    if (operator === 'plus') {
      bathrooms = bathrooms + 1
      if (bathrooms > 10) bathrooms = 10
    } else {
      bathrooms = bathrooms - 1
      if (bathrooms < 0) bathrooms = 0
    }
    this.setState({ bathrooms }, this.updateList)
  }
  handleCars = (operator) => {
    let { carparks } = this.state
    if (operator === 'plus') {
      carparks = carparks + 1
      if (carparks > 10) carparks = 10
    } else {
      carparks = carparks - 1
      if (carparks < 0) carparks = 0
    }
    this.setState({ carparks }, this.updateList)
  }

  onSubmit = (e) => {
    e.preventDefault()
    e.target.querySelector('input[name="price_min"]').value = this.state.price_min?.value || ''
    e.target.querySelector('input[name="price_max"]').value = this.state.price_max?.value || ''
    e.target.querySelector('input[name="location"]').value = this.state.location?.value || ''
    e.target.querySelector('input[name="type"]').value = this.state.type?.value || ''
    e.target.submit()
  }

  autoComplete = () => {
    if (!this.props.home) return
    const self = this
    let { results } = this.state
    if( this.autoCompleteJS !== null ) {
      this.autoCompleteJS.unInit()
    }
    this.autoCompleteJS = new autoComplete({
      data: {
        src: results,
        keys: ["title"],
        cache: true,
        filter: (list) => {
          const filteredResults = Array.from(
            new Set(list.map((value) => value.match))
          ).map((food) => {
            return list.find((value) => value.match === food);
          });
    
          return filteredResults;
        }
      },
      resultsList: {
        noResults: true,
        maxResults: 15,
        tabSelect: true
      },
      resultItem: {
        element: (item, data) => {
          // Modify Results Item Style
          item.style = "display: flex; justify-content: space-between;";
          // Modify Results Item Content
          item.innerHTML = `
          <span style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
            ${data.match}
          </span>`;
        },
        highlight: true
      },
      events: {
        input: {
          focus: () => {
            if (this.autoCompleteJS.input.value.length) this.autoCompleteJS.start();
          }
        }
      }
    })
    this.autoCompleteJS.input.addEventListener("selection", (event) => {
      const feedback = event.detail;
      this.autoCompleteJS.input.blur();
      // Prepare User's Selected Value
      const selection = feedback.selection.value[feedback.selection.key];
      // Replace Input value with the selected value
      this.autoCompleteJS.input.value = selection;
      // Console log autoComplete data feedback
      this.setState({
        autocomplete: true,
        search: selection
      })
    })
  }

  render() {
    let { action, price_min, price_max, bedrooms, bathrooms, carparks, category, property_type, searchPlaceholder, moreOptions, type, location } = this.state

    let typeLabel = 'For Sale'

    // return the label inside categories array where the value matches type
    return (
      <section className={`search ${moreOptions && 'active'}`}>
        <div className="search__inner">
          <ul className='search__mobile-categories'>
            <li><Link to='/for-sale/' className={`btn${typeLabel === 'For Sale' ? ' active' : ''}`}>For Sale</Link></li>
            <li><Link to='/for-lease/' className={`btn${typeLabel === 'For Lease' ? ' active' : ''}`}>For Lease</Link></li>
            <li><Link to='/sold/' className={`btn${typeLabel === 'Sold' ? ' active' : ''}`}>Sold</Link></li>
            <li><Link to='/team/' className="btn">Agents</Link></li>
          </ul>
          <form className='search__form form' action={action} onSubmit={(e) => this.onSubmit(e)}>
            <div className="form__row">
              <div className='form__select form__select--property-type'>
                <Select
                  options={propertyType}
                  onChange={this.handleSelectChange}
                  openMenuOnFocus={true}
                  isSearchable={false}
                  id="property_type"
                  name="property_type"
                  value={property_type}
                  placeholder='Residential'
                  className="react-select-container"
                  classNamePrefix="react-select"
                  ref={node => this.property_type = node}
                />
              </div>
              <div className='form__select form__select--category'>
                <Select
                  options={categories}
                  onChange={this.handleSelectChange}
                  openMenuOnFocus={true}
                  isSearchable={false}
                  id="category"
                  name="category"
                  value={category}
                  placeholder={typeLabel}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  ref={node => this.category = node}
                />
              </div>

              <input 
                className="form__input" type="text" name="search" 
                value={this.props.search} 
                placeholder={searchPlaceholder} 
                onKeyDown={() => this.setState({ autocomplete: false })} 
                id="autoComplete"
              />

              <div className='form__select form__select--price-range'>
                <Select
                  options={(category?.value === 'for-lease') ? rentRangeMin : priceRangeMin}
                  onChange={this.handleSelectChange}
                  openMenuOnFocus={true}
                  isSearchable={false}
                  id="price_min"
                  name="price_min"
                  value={price_min}
                  placeholder="Price Min"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  ref={node => this.price_min = node}
                />
              </div>

              <div className='form__select form__select--price-range'>
                <Select
                  options={(category?.value === 'for-lease') ? rentRangeMax : priceRangeMax}
                  onChange={this.handleSelectChange}
                  openMenuOnFocus={true}
                  isSearchable={false}
                  id="price_max"
                  name="price_max"
                  value={price_max}
                  placeholder="Price Max"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  ref={node => this.price_max = node}
                />
              </div>

              <button
                type='button'
                className={`form__toggle ${moreOptions ? 'active' : ''}`}
                onClick={() => this.setState({ moreOptions: !moreOptions })}
              >
                {moreOptions ? 'Less' : 'More'} Filters
                <Options color={'#000000'} />
              </button>
              <button className='form__submit' type='submit'>Search</button>
            </div>
            <div className={`form__row form__row--dropdowns${moreOptions ? ' active': ''}`}>
              <div className='form__select form__select--type'>
                <Select
                  options={typeOptions}
                  onChange={this.handleSelectChange}
                  openMenuOnFocus={true}
                  isSearchable={false}
                  id="type"
                  name="type"
                  value={type}
                  placeholder="Type"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  ref={node => this.type = node}
                />
              </div>
              <div className='form__select form__select--location'>
                <Select
                  options={
                    this.state.suburbs.map((el, i) => {
                      return { label: el, value: el }
                    })
                  }
                  onChange={this.handleSelectChange}
                  openMenuOnFocus={true}
                  isSearchable={false}
                  id="location"
                  name="location"
                  value={location}
                  placeholder="Location"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  ref={node => this.location = node}
                />
              </div>
              <div className='form__number form__select--bed'>
                <label>Beds</label>
                <button type='button' className='form__number-minus' onClick={() => this.handleBedrooms('minus')}>
                  <QtyMinus />
                </button>
                <input className='form__number-input' type="number" name="bedrooms" value={bedrooms} min="0" max="10" readOnly />
                <button type='button' className='form__number-plus' onClick={() => this.handleBedrooms('plus')}>
                  <QtyPlus />
                </button>
              </div>
              <div className='form__number form__select--bath'>
                <label>Baths</label>
                <button type='button' className='form__number-minus' onClick={() => this.handleBaths('minus')}>
                  <QtyMinus />
                </button>
                <input className='form__number-input' type="number" name="bathrooms" value={bathrooms} min="0" max="10" readOnly />
                <button type='button' className='form__number-plus' onClick={() => this.handleBaths('plus')}>
                  <QtyPlus />
                </button>
              </div>
              <div className='form__number form__select--car'>
                <label>Cars</label>
                <button type='button' className='form__number-minus' onClick={() => this.handleCars('minus')}>
                  <QtyMinus />
                </button>
                <input className='form__number-input' type="number" name="carparks" value={carparks} min="0" max="10" readOnly />
                <button type='button' className='form__number-plus' onClick={() => this.handleCars('plus')}>
                  <QtyPlus />
                </button>
              </div>
              <button
                type='button'
                className='form__close'
                onClick={(e) => this.onSubmit(e)}
              >
                Search
              </button>
            </div>
          </form>
        </div>
      </section>
    )
  }
}

export default ClickSearchForm